import store from "../../../../../store";
import { BrandsEndPointLogic } from "../../../../../logic/Partners/DataIntegrations/BrandsEndPointLogic";
import {
  RUN_PROCESS_FETCHER_CONFIG_QUERY_ID,
  RUN_PROCESS_INDUSTRY_QUERY_ID,
} from "../constants";

let inFlight: Promise<any> | null = null;

// The Run Process wizard (reused from the legacy module) needs two site-wide
// datasets — fetcherConfigData / brandIndustryData in brandConfigurationReportSlice
// — for its "By Flow" mode. These used to be fetched eagerly on every table
// mount (All Brands / Needs Configuration / Not Connected), which fired both
// queries on page load AND again on every tab switch, even for users who
// never open the wizard. Call this instead, right before opening the modal —
// it fetches once (checked against the slice, guarded against concurrent
// calls) and is a no-op afterwards.
export function ensureRunProcessSupportData(oauthTokenHeader: any) {
  const { fetcherConfigData, brandIndustryData } = store.getState().brandConfigurationReport;
  const alreadyFetched =
    Boolean(fetcherConfigData?.query_output) && Boolean(brandIndustryData?.query_output);
  if (alreadyFetched) return Promise.resolve();
  if (inFlight) return inFlight;

  inFlight = Promise.all([
    BrandsEndPointLogic.getAllConfigForFetcher(
      oauthTokenHeader,
      RUN_PROCESS_FETCHER_CONFIG_QUERY_ID,
      "test",
    ),
    BrandsEndPointLogic.getBrandsForIndustry(
      oauthTokenHeader,
      RUN_PROCESS_INDUSTRY_QUERY_ID,
      "test",
    ),
  ]).finally(() => {
    inFlight = null;
  });
  return inFlight;
}
